// 概要 tab — usage bar + visual IP map.
import { Stack } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import IpMap, { IpMapLegend } from '../IpMap';

export const OverviewTab = ({ activeVlan, allEntries, loading, mapMode, setMapMode, onCellClick, onOpenRanges }) => {
  const assignedCount = activeVlan?.assigned ?? allEntries.filter((e) => e.status === 'assigned').length;
  const totalCount = activeVlan?.total ?? allEntries.length;
  const usagePct = totalCount ? Math.round((assignedCount / totalCount) * 100) : 0;
  return (
    <div className="space-y-4">
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5" data-testid="vlan-selector">
        <div className="flex items-center justify-between text-sm mb-2">
          <span className="font-semibold text-zinc-800">{activeVlan?.name} <span className="font-mono text-xs text-zinc-400 ml-1">{activeVlan?.subnet}</span></span>
          <span className="text-zinc-500 tabular-nums">{assignedCount}/{totalCount} 使用中 <span className={`ml-1.5 font-semibold ${usagePct >= 90 ? 'text-rose-600' : 'text-teal-700'}`}>{usagePct}%</span></span>
        </div>
        <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
          <div className={`h-full rounded-full transition-all duration-500 ${usagePct >= 90 ? 'bg-rose-500' : 'bg-teal-700'}`} style={{ width: `${usagePct}%` }} />
        </div>
      </div>
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5 space-y-4">
        <div className="flex items-center justify-between gap-2 flex-wrap">
          <span className="text-sm font-semibold text-zinc-700">IPマップ</span>
          <div className="flex items-center gap-2">
            <Button variant="outline" size="sm" data-testid="purpose-ranges-btn" onClick={onOpenRanges} className="h-8 rounded-lg text-xs">
              <Stack size={14} className="mr-1" /> 用途レンジ設定
            </Button>
            <div className="inline-flex rounded-lg border border-slate-200 p-0.5 bg-slate-50" data-testid="map-mode-toggle">
              {[['state', '状態'], ['purpose', '用途']].map(([m, label]) => (
                <button
                  key={m}
                  type="button"
                  data-testid={`map-mode-${m}`}
                  onClick={() => setMapMode(m)}
                  className={`px-3 h-8 rounded-md text-xs font-medium transition-colors ${mapMode === m ? 'bg-white text-teal-700 shadow-sm' : 'text-zinc-500 hover:text-zinc-700'}`}
                >
                  {label}で色分け
                </button>
              ))}
            </div>
          </div>
        </div>
        {loading ? <p className="text-center text-zinc-400 py-10">読み込み中...</p> : (
          <IpMap entries={allEntries} subnet={activeVlan?.subnet} mode={mapMode} onCellClick={onCellClick} />
        )}
        <IpMapLegend mode={mapMode} />
        <p className="text-[11px] text-zinc-400">セルをクリックすると編集パネルが開きます。空きセルをクリックして新規割当も可能です。</p>
      </div>
    </div>
  );
};
